import { Reveal } from "./Reveal";

const BRANDS = ["Compass", "RE/MAX", "Century 21", "Keller Williams", "Coldwell Banker", "eXp Realty"];

export const ProofStrip = () => (
  <section className="border-t border-ink/10 py-14 md:py-16" data-testid="proof-strip">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal>
        <p className="text-center text-[11px] uppercase tracking-[0.2em] text-ink/45 mb-8">
          Compatible with agents at every major brokerage
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-5">
          {BRANDS.map((b) => (
            <span
              key={b}
              className="font-serif text-xl md:text-2xl text-ink/35 hover:text-ink/70 transition-colors duration-300"
            >
              {b}
            </span>
          ))}
        </div>
        <p className="mt-8 text-center text-xs text-ink/45">
          Compatible with every major brokerage · No IT approval needed
        </p>
      </Reveal>
    </div>
  </section>
);
